import * as React from 'react';
import { CalendarOutlined } from '@ant-design/icons';
import { AgentCommissionStatus } from 'app/shared/model/AgentCommissionDto';
import { RatesDates } from 'app/pages/AgentPricing/models';
import { DateDisplay } from 'app/shared/ui/DateDisplay';

interface DiscountDatesDisplayProps {
    status: AgentCommissionStatus;
    dates: RatesDates;
}

function labelColour(status: AgentCommissionStatus): string {
    switch(status) {
        case AgentCommissionStatus.Active:
            return 'green';
        case AgentCommissionStatus.FutureStart:
            return 'gold';
        case AgentCommissionStatus.Expired:
            return 'red';
        default:
            return 'default';
    }
}

function datesText(dates: RatesDates) {
    return  (dates.endDate !== undefined && dates.endDate !== null)
        ? <>Effective between: {DateDisplay(dates.startDate)} - {DateDisplay(dates.endDate)}</>
        : <>Effective from: {DateDisplay(dates.startDate)}</>
}

export function DiscountDatesDisplay(props: DiscountDatesDisplayProps) {
    const statusColor = labelColour(props.status);
    const isFutureStart = props.status === AgentCommissionStatus.FutureStart;
    
    return (
        <div className="discount-date-widget">
            <div
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '8px 16px',
                    borderRadius: 4,
                    backgroundColor: isFutureStart ? '#fff1f0' : statusColor === 'green' ? '#f6ffed' : statusColor === 'red' ? '#fff1f0' : '#fffbe6',
                    border: isFutureStart ? '1px solid #ffccc7' : statusColor === 'green' ? '1px solid #b7eb8f' : statusColor === 'red' ? '1px solid #ffccc7' : '1px solid #ffe58f',
                    color: isFutureStart ? '#cf1322' : statusColor === 'green' ? '#389e0d' : statusColor === 'red' ? '#cf1322' : '#d46b08',
                    fontSize: '14px',
                    fontWeight: 400
                }}
            >
                <CalendarOutlined style={{ fontSize: 14 }} />
                <span>{datesText(props.dates)}</span>
            </div>
        </div>
    );
}